/**
 * Per-device, per-user sound notification preference.
 *
 * Sound playback (e.g. the in-app notification chime triggered from AppSidebar)
 * is gated by this flag. Stored in localStorage because it's a device-level
 * preference — users often want different behavior on their phone vs. their
 * reading workstation — and so we don't need a backend migration.
 *
 * Key format: `sound-notifications-muted:<userRole>:<userId>`
 */

const KEY_PREFIX = "sound-notifications-muted";
export const SOUND_PREFERENCE_CHANGE_EVENT = "radiolinq:sound-preference-change";

function storageKey(userRole: string | undefined, userId: number | string | undefined): string | null {
  if (!userRole || userId == null || userId === "") return null;
  return `${KEY_PREFIX}:${userRole}:${userId}`;
}

export function isSoundNotificationsMuted(
  userRole: string | undefined,
  userId: number | string | undefined
): boolean {
  const key = storageKey(userRole, userId);
  if (!key) return false;
  try {
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
}

export function setSoundNotificationsMuted(
  userRole: string | undefined,
  userId: number | string | undefined,
  muted: boolean
): void {
  const key = storageKey(userRole, userId);
  if (!key) return;
  try {
    if (muted) localStorage.setItem(key, "true");
    else localStorage.removeItem(key);
    window.dispatchEvent(
      new CustomEvent(SOUND_PREFERENCE_CHANGE_EVENT, { detail: { muted } })
    );
  } catch {
    /* noop */
  }
}
